import React from 'react'
import Link from 'gatsby-link'

import Face from '../../images/Facebook.svg'
import Insta from '../../images/Instagram.svg'
import You from '../../images/Youtube.svg'
import Gitlab from '../../images/Gitlab.svg'
import ReactSvg from '../../images/React.svg'
import Netlify from '../../images/Netlify.svg'

const Footer = () => (
  <section className="footerContainer">
    <article>
      <div className="container full-Width" style={{alignItems:'baseline'}}>
        <div className="half-Width-25 mobBottommargin">
          <div>
            <h3>Quick Links.</h3>
            <ul>
              <li><Link to="/" className='slide'>Home</Link></li>
              <li><Link to="/about/" className='slide'>About</Link></li>
              <li><Link to="/services/" className='slide'>Services</Link></li>
              <li><Link to="/case-studies/" className='slide'>Case Studies</Link></li>
              <li><Link to="/blog/" className='slide'>Blog</Link></li>
              <li><Link to="/contact/" className='slide'>Contact</Link></li>
            </ul>
          </div>
        </div>
        <div className="half-Width-25 mobBottommargin">
          <div>
            <h3>Important Links.</h3>
            <ul>
            <li><Link to="/terms-and-conditions/" className='slide'>Terms and Conditions</Link></li>
            <li><Link to="/privacy-policy/" className='slide'>Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="half-Width-25 mobBottommargin">
          <div>
            <h3>Follow Us.</h3>
            <p style={{margin:'0', display:'inline-flex', alignItems:'center'}}>
              <span style={{marginRight:'.25rem'}}>
                <a href="https://www.facebook.com/Nisadhya.Marketing/" target="_blank" rel="nofollow">
                <img src={Face} className="socialIcons" alt="Facebook" title="Facebook"/>
                </a>
              </span>
              <span style={{marginRight:'.25rem'}}>
              <a href="https://www.instagram.com/nisadhya/" target="_blank" rel="nofollow">
                <img src={Insta} className="socialIcons" alt="Instagram" title="Instagram"/>
              </a>
              </span>
              <a href="https://www.youtube.com/" target="_blank" rel="nofollow">
                <img src={You} className="socialIcons" alt="YouTube" title="YouTube"/>
              </a>
            </p>
          </div>
        </div>
        <div className="half-Width-25">
          <div>
            <h3>Contact Us.</h3>
            <ul>
              <li>contact@nisadhya.com</li>
              <li>+977 01-4433084</li>
              <br/>
              <li>Lazimpat -3, Kathmandu</li>
              <li>Nepal</li>
            </ul>
          </div>
        </div>
      </div>
    </article>
    <article className="copyrightContainer">
      <div className="container full-Width" style={{padding:'1.5rem 1.0875rem'}}>
        <div className="half-Width-75 mob-centerAlign">
          <div className="copyrightDiv">
            <p style={{margin:'0'}}>&copy; Copyright 2018 <br className="mobBreak"/> Nisadhya Digital Marketing Pvt Ltd.</p>
          </div>
        </div>
        <div className="half-Width-25">
        <div className="socialDiv">
          <p style={{margin:'0', display:'inline-flex', alignItems:'center'}}>
            <span style={{marginRight:'.5rem'}}>Powered By:</span>
            <span style={{marginRight:'.25rem'}}>
              <a href="https://gitlab.com/" target="_blank" rel="nofollow">
              <img src={Gitlab} className="socialIcons" alt="Gitlab" title="Gitlab"/>
              </a>
            </span>
            <span style={{marginRight:'.25rem'}}>
              <a href="https://netlify.com" target="_blank" rel="nofollow">
                <img src={Netlify} className="socialIcons" alt="Netlify" title="Netlify"/>
              </a>
            </span>
            <a href="https://reactjs.org/" target="_blank" rel="nofollow">
              <img src={ReactSvg} className="socialIcons" alt="React" title="React"/>
            </a>
          </p>
        </div>
        </div>
      </div>
    </article>
  </section>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js